import { render } from "./edit-comp.vue?vue&type=template&id=45cbe5f2&scoped=true"
import script from "./edit-comp.vue?vue&type=script&lang=js"
export * from "./edit-comp.vue?vue&type=script&lang=js"

import "./edit-comp.vue?vue&type=style&index=0&id=45cbe5f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cbe5f2"]])

export default __exports__